const UseFormatDate = (date) => {
    return new Date(date).toLocaleString()
}

export default UseFormatDate;

